import { render, staticRenderFns } from "./CarDriverAppointStaffView.vue?vue&type=template&id=fb445744"
import script from "./CarDriverAppointStaffView.vue?vue&type=script&lang=js"
export * from "./CarDriverAppointStaffView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports